export const TIME_LIMITS = {
  timeFrom: {
    start: {
      hours: 9,
      minutes: 0,
      string: '09:00'
    },
    end: {
      hours: 17,
      minutes: 0,
      string: '17:00'
    }
  },
  timeUntil: {
    start: {
      hours: 10,
      minutes: 0,
      string: '10:00'
    },
    end:  {
      hours: 18,
      minutes: 0,
      string: '18:00'
    }
  }
};

export const TODAY_HOURS_MIN_DIFFERENCE = 2;
export const MAX_BOOKING_DAYS_AHEAD = 360;
export const SECONDS_IN_MINUTE = 60;
export const MILLISECONDS_IN_SECONDS = 1000;

export const LOCALES_WITH_12H_FORMAT = ['en-US'];
